<script>
	import { onMount } from 'svelte';

	import LandingScreen from './LandingScreen.svelte';
	import TubeMap from './TubeMap.svelte';

	let data = false;
	onMount( async () => {
		let response = await fetch("data/stations_prices.json")
		data = await response.json()
	})

	$: console.log(data);

	let showMap = false;

	$: windowWidth = 0;

</script>

<svelte:window bind:innerWidth={windowWidth} />

<div class='con'>
	{#if data}
		{#if !showMap}
		<!-- {#if false} -->
		<LandingScreen {data} on:show-map={() => showMap = true} />
		{:else}
		<TubeMap {data} initialWindowWidth={windowWidth} />
		{/if}
	{/if}
</div>

<style>
	
</style>